:host {
	display: block;
	border-style: solid;
	border-width: 1px;
	border-radius: 3px;
}
:host[hidden] {
	display: none;
}
:host[disabled] {
	opacity: 0.5;
}
:host > button {
	border-color: transparent;
	background-color: transparent;
	padding: 0.2em 0.3em;
	font-size: 110%;
	font-weight: 400;
}
:host:not([disabled]):hover,
:host:not([disabled]):focus,
:host:not([disabled]):active {
	border-color: var(--smoothly-trigger-border);
}
:host[expand=full] > button,
:host[expand=block] > button {
	width: 100%;
}
:host[expand=full] {
	border-left: none;
	border-right: none;
}
